export default "__VITE_PUBLIC_ASSET__25bd9097__"